import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const Help = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ sx, ...props }, ref) => (
    <SvgIcon
      viewBox="0 0 14 14"
      {...props}
      sx={{ fill: 'none', ...(sx || {}) }}
      ref={ref}
    >
      <path
        d="M6.40497 8.27337H7.52497V8.06749C7.52497 7.10396 8.92497 7.14514 8.92497 5.76161C8.92497 4.79808 8.23321 4.14749 7.03086 4.14749C5.83674 4.14749 5.07086 4.78985 5.07086 6.03337V6.1322H6.15791V6.03337C6.15791 5.5969 6.40497 5.11926 7.01439 5.11926C7.59909 5.11926 7.79674 5.58043 7.79674 5.8769C7.79674 6.70867 6.40497 6.66749 6.40497 8.05926V8.27337ZM6.95674 10.1593C7.30262 10.1593 7.59086 9.90396 7.59086 9.52514C7.59086 9.14632 7.30262 8.89102 6.95674 8.89102C6.61086 8.89102 6.32262 9.14632 6.32262 9.52514C6.32262 9.90396 6.61086 10.1593 6.95674 10.1593Z"
        fill="currentColor"
      />
      <circle cx="7" cy="7" r="6.5" stroke="currentColor" />
    </SvgIcon>
  )
);

Help.displayName = 'Help';
